import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../../../shared/shared.module';
import { VesselEditComponent } from './vessel-edit.component';
import { VesselEditRoutingModule } from './vessel-edit-routing.module';
import { VesselEditResolve } from './vessel-edit.resolve';
import { FileListModule } from '../../../../../shared/file-list/file-list.module';
import { PhotoListModule } from '../../../../../shared/photo-list/photo-list.module';
import { ImageCropperModule } from 'ngx-img-cropper';
import { BoatLocationFormModule } from '../form/boat-location/boat-location.module';
import { BoatInformationFormModule } from '../form/boat-information/boat-information.module';
import { CharterScheduleFormModule } from '../form/charter-schedule/charter-schedule.module';
import { DescriptionAndFeaturesFormModule } from '../form/description-and-features/description-and-features.module';
import { HistoryFormModule } from '../form/history/history.module';
import { AdminFormModule } from '../form/admin/admin.module';
import { InsuranceFormModule } from '../form/insurance/insurance.module';
import { NotesFormModule } from '../form/notes/notes.module';
import { PhotosAndVideoFormModule } from '../form/photos-and-video/photos-and-video.module';
import { ServicesAndPricingFormModule } from '../form/services-and-pricing/services-and-pricing.module';
import { RequestEditModule } from '../form/request-edit/request-edit.module';
import { CaptainInformationModule } from '../form/captain-information/captain-information.module';
import { BoatOwnerAvailabilityModule } from '../form/availability/boat-owner-availability/boat-owner-availability.module';
import { AsyncButtonModule } from '../../../../../shared/directives/async-button/async-button.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    VesselEditRoutingModule,
    MatDialogModule,
    MatExpansionModule,
    FileListModule,
    MatIconModule,
    MatCheckboxModule,
    MatSliderModule,
    PhotoListModule,
    ImageCropperModule,
    BoatLocationFormModule,
    BoatInformationFormModule,
    CharterScheduleFormModule,
    CaptainInformationModule,
    DescriptionAndFeaturesFormModule,
    HistoryFormModule,
    AdminFormModule,
    InsuranceFormModule,
    NotesFormModule,
    PhotosAndVideoFormModule,
    ServicesAndPricingFormModule,
    RequestEditModule,
    BoatOwnerAvailabilityModule,
    AsyncButtonModule,
  ],
  declarations: [VesselEditComponent],
  entryComponents: [],
  exports: [VesselEditComponent],
  providers: [VesselEditResolve],
})
export class VesselEditModule {}
